import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-mist" data-id="element-110" data-mp="2lu4o5ip4lm78">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8" data-id="element-111" data-mp="30hhb9bukzzzq">
        <SectionHeader id="problema" eyebrow="¿Te suena familiar?" title="Sabes electrónica o das clases técnicas, pero preparar cada tema, práctica y actividad te lleva demasiado tiempo." description="Si eres profesor, instructor, técnico o estás comenzando a enseñar electrónica, probablemente conozcas alguna de estas situaciones:" data-id="element-112" data-mp="30j0w7fr6mz7u" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-113" data-mp="3jdzccjvblc8n">
          {problems.map(p => {
          const Icon = p.icon;
          return <li key={p.title} className="flex gap-2.5 rounded-lg border-l-4 border-alert bg-white p-2.5 shadow-sm sm:p-3" data-id="element-114" data-mp="1p196d3rogckw">
                <Icon size={18} aria-hidden="true" className="mt-0.5 flex-shrink-0 text-brand" data-id="element-115" data-mp="1k499njgpwm6g" />
                <div data-id="element-116" data-mp="jeeomg1zv5eu">
                  <h3 className="font-condensed text-[0.95rem] font-bold leading-tight text-navy" data-id="element-117" data-mp="jey65vnqfrsc">{p.title}</h3>
                  <p className="mt-0.5 text-[0.8rem] leading-snug text-navy/75 sm:text-sm" data-id="element-118" data-mp="o9u1b4o9mv9o">{p.desc}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}